export class MoleculePanelOverviewHeaderMultiRestoreDatabaseActionComponent {
    public templateUrl = require('./multi-restore-database-action.html?external');
}
